import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { TabButtonsGroupConfigInterface } from '~/component/tab-buttons-group/interfaces/config.interface';
import { ValueAccessorBase } from '~/component/value-accessor.base';

@Component({
  selector: 'app-tab-buttons-group',
  templateUrl: './tab-buttons-group.component.html',
  styleUrls: ['./tab-buttons-group.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: TabButtonsGroupComponent,
      multi: true,
    },
  ],
})
export class TabButtonsGroupComponent extends ValueAccessorBase<string> {
  @Input() public buttonsConfig: TabButtonsGroupConfigInterface[];

  public isActive(buttonName: string): boolean {
    return this.value === buttonName;
  }

  public selectItem(buttonName: string): void {
    this.value = buttonName;
  }
}
